const ButtonSpinner = () => {
  return (
    <div className='flex justify-center align-center'>
      <div className='loader loader-button'></div>
    </div>
  );
};
export default ButtonSpinner;
